import { render, staticRenderFns } from "./CatalogoCorrectivo.vue?vue&type=template&id=465ab748&scoped=true&"
import script from "./CatalogoCorrectivo.vue?vue&type=script&lang=js&"
export * from "./CatalogoCorrectivo.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoCorrectivo.vue?vue&type=style&index=0&id=465ab748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ab748",
  null
  
)

export default component.exports